export default {
    "title": "Deutsch",

    "加载中...": "Wird geladen...",
    "没有更多数据": "Keine weiteren Daten",
    "暂无数据": "Noch keine Daten",
    "取消": "Abbrechen",
    "确认": "Bestätigen",
    "确定": "Sicher",
    "完成": "Fertig",
    "我知道了": "Verstanden",
    "开始": "Starten",
    "结束": "Beenden",
    "提示": "Hinweis",
    "提交": "Absenden",
    "请输入": "Bitte eingeben",
    "请输入33": "Bitte geben Sie 33 ein",
    "请选择": "Bitte wählen",
    "请选择33": "Bitte wählen Sie 33 aus",
    "成功": "Erfolg",
    "失败": "Fehlgeschlagen",
    "错误": "Fehler",
    "复制": "Kopieren",
    "复制成功": "Erfolgreich kopiert",
    "复制失败": "Kopieren fehlgeschlagen",
    "© 2009-2025 XXX 版权所有": "© 2009-2025 XXX Alle Rechte vorbehalten",
    
    "星期一": "Mo.",
    "星期二": "Di.",
    "星期三": "Mi.",
    "星期四": "Do.",
    "星期五": "Fr.",
    "星期六": "Sa.",
    "星期日": "So.",

    "一月": "Januar",
    "二月": "Februar",
    "三月": "März",
    "四月": "April",
    "五月": "Mai",
    "六月": "Juni",
    "七月": "Juli",
    "八月": "August",
    "九月": "September",
    "十月": "Oktober",
    "十一月": "November",
    "十二月": "Dezember",
    
    "语言": "Sprache",
    "立即开始": "Jetzt starten",
    "登录": "Anmelden",
    "注册": "Registrieren",
    "记住密码": "Passwort merken",
    "忘记密码": "Passwort vergessen",
    "手机号": "Handynummer",
    "密码": "Passwort",
    "登录密码": "Anmeldepasswort",
    "确认密码": "Passwort bestätigen",
    "邀请码": "Einladungscode",
    "我同意": "Ich stimme zu",
    "条款&协议": "Geschäftsbedingungen",
    "注册条款": "Registrierungsbedingungen",
    "创建账号": "Konto erstellen",
    "修改密码": "Passwort ändern",
    "请根据以下内容修改密码": "Bitte ändern Sie Ihr Passwort gemäß den folgenden Inhalten",
    "提现密码": "Auszahlungs-Passwort",
    "当前密码": "Aktuelles Passwort",
    "新密码": "Neues Passwort",
    "请再次输入新密码": "Bitte geben Sie das neue Passwort erneut ein",
    "你确定要登出当前账号吗？": "Sind Sie sicher, dass Sie sich von Ihrem Konto abmelden möchten?",
    "选择国家代码": "Ländervorwahl auswählen",

    "开始预订": "Jetzt buchen",
    "订单历史": "Bestellverlauf",
    "个人资料": "Profil",
    "会员资格": "Mitgliedschaft",
    "事件": "Veranstaltung",
    "联系我们": "Kontakt",
    "钱包信息": "Brieftaschen-Informationen",
    "提现": "Auszahlung",
    "证书": "Zertifikat",
    "设置": "Einstellungen",
    "其他": "Allgemein",
    "安全中心": "Sicherheitszentrum",
    "关于我们": "Über uns",
    "常见问题": "FAQ",
    "用户ID": "Benutzer-ID",
    "账户余额": "Kontostand",
    "信用评分": "Kredit-Score",
    "充值": "Aufladen",
    "存款": "Einzahlung",
    "退出登录": "Abmelden",
    "立即查看": "Jetzt ansehen",

    "邀请好友": "Freunde einladen",
    "复制你的邀请码，与好友分享": "Kopiere deinen Einladungscode und teile ihn mit Freunden",
    "当前等级": "Aktuell",
    "佣金率": "Provisionssatz",
    "每日订单": "Tägliche Bestellungen",

    "钱包余额": "Brieftaschen-Guthaben",
    "充值金额": "Einzahlungsbetrag",
    "支付类型": "Zahlungsart",
    "支付银行": "Zahlungsbank",
    "钱包地址": "Brieftaschen-Adresse",
    "二维码": "QR-Code",
    "充值渠道": "Einzahlungskanal",
    "充值凭证": "Einzahlungsbeleg",
    "请联系在线客服获取最新的存款信息。如果存款信息有误，将影响您的转账验证，导致转账失败，平台对此不承担任何责任。": "Bitte kontaktieren Sie unseren Live-Chat für die aktuellen Einzahlungsinformationen. Bei falschen Einzahlungsdaten kann die Verifizierung fehlschlagen; die Plattform übernimmt keine Haftung.",
    "你还没有设置提现密码，请前往设置": "Sie haben noch kein Auszahlungs-Passwort festgelegt. Bitte gehen Sie zu den Einstellungen.",
    "提现到": "Auszahlen an",
    "暂无333可用": "Keine 333 verfügbar",
    "请先将333关联到您的账户，然后再进行提现。": "Bitte verknüpfen Sie zuerst 333 mit Ihrem Konto, bevor Sie eine Auszahlung vornehmen.",
    "链接333": "333 verknüpfen",
    "金额": "Betrag",
    "提现金额": "Auszahlungsbetrag",
    "加密钱包": "Krypto-Wallet",
    "银行卡": "Bankkarte",
    "钱包": "Brieftasche",
    "提现历史": "Auszahlungsverlauf",
    "手续费": "Gebühr",
    "到账金额": "Empfangener Betrag",
    "银行卡号": "Bankkartennummer",
    "Pix账号": "Pix-Konto",
    "备注": "Bemerkungen",
    "立即关联您的333": "Verknüpfen Sie jetzt Ihr 333",
    "Pix类型": "Pix-Typ",
    "地址": "Adresse",
    "网络": "Netzwerk",
    "持卡人姓名": "Name des Karteninhabers",
    "银行列表": "Bankliste",
    "账户历史": "Kontoverlauf",
    "你确定要删除此地址吗": "Sind Sie sicher, dass Sie diese Adresse löschen möchten?",
    "你确定要删除此账号吗": "Sind Sie sicher, dass Sie dieses Konto löschen möchten?",

    "全部": "Alle",
    "待处理": "Ausstehend",
    "冻结中": "Eingefroren",
    "已完成": "Abgeschlossen",
    "每日佣金": "Tagesprovision",
    "总奖金": "Gesamtbonus",
    "冻结": "Ausgesetzt",
    "订单数量": "Bestellanzahl",
    "订单集数量": "Anzahl der Bestellgruppen",
    "现在开始": "Jetzt starten",
    "热门预订": "Beliebte Buchungen",
    "0条评论": "333 Bewertungen",
    "普通订单": "Normale Bestellung",
    "价格": "Preis",
    "佣金": "Provision",
    "评分": "Bewertung",
    "评论": "Kommentar",
    "选择评论": "Kommentar auswählen",

    "comment_1": `Das Tourismuspaket war absolut fantastisch und übertraf alle meine Erwartungen.`,
    "comment_2": `Ich hatte mit dem von mir gebuchten Tourismuspaket ein unglaubliches Erlebnis.`,
    "comment_3": `Die Liebe zum Detail im Tourismuspaket war bemerkenswert.`,
    "comment_4": `Ich habe mich während des gesamten Tourismuspakets verwöhnt und gut umsorgt gefühlt.`,
    "comment_5": `Die im Tourismuspaket enthaltenen Aktivitäten waren spannend und mitreißend.`,
    "comment_6": `Ich kann dieses Tourismuspaket kaum genug empfehlen; es machte meinen Urlaub wirklich unvergesslich.`,
    "comment_7": `Von Anfang bis Ende bot das Tourismuspaket ein nahtloses und angenehmes Erlebnis.`,
    "comment_8": `Die Reiseroute des Tourismuspakets war ausgewogen und bot eine Mischung aus Erholung und Abenteuer.`,
    "comment_9": `Die Reiseleiter und Mitarbeiter des Tourismuspakets waren freundlich, kompetent und zuvorkommend.`,
    "comment_10": `Das Tourismuspaket ermöglichte es mir, in die lokale Kultur einzutauchen und wirklich einen Bezug zum Reiseziel zu bekommen.`,
    "comment_11": `Die Unterkünfte im Tourismuspaket waren luxuriös und komfortabel.`,
    "comment_12": `Die im Tourismuspaket bereitgestellte Beförderung war praktisch und problemlos.`,
    "comment_13": `Ich fühlte mich während des gesamten Tourismuspakets wie ein VIP.`,
    "comment_14": `Die Vielfalt der im Tourismuspaket enthaltenen Speiseoptionen präsentierte die lokale Küche auf wunderbare Weise.`,
    "comment_15": `Das Tourismuspaket bot zahlreiche Möglichkeiten für atemberaubende Ausblicke und Naturschönheiten.`,
    "comment_16": `Ich traf wunderbare Menschen und schloss während des Tourismuspakets lebenslange Freundschaften.`,
    "comment_17": `Die Unterhaltungs- und Kulturerlebnisse im Tourismuspaket waren fesselnd und bereichernd.`,
    "comment_18": `Dank der Flexibilität des Tourismuspakets konnte ich frei erkunden und versteckte Schmuckstücke entdecken.`,
    "comment_19": `Das Preis-Leistungs-Verhältnis dieses Tourismuspakets war hervorragend.`,
    "comment_20": `Die Kommunikation und Organisation im Vorfeld des Tourismuspakets war ausgezeichnet.`,
    "comment_21": `Das Tourismuspaket bot eine perfekte Balance aus Erholung, Abenteuer und kulturellem Eintauchen.`,
    "comment_22": `Ich fühlte mich während des gesamten Tourismuspakets sicher und geborgen.`,
    "comment_23": `Das Tourismuspaket bot einzigartige und abseits der üblichen Pfade liegende Erlebnisse.`,
    "comment_24": `Die Aufmerksamkeit für Nachhaltigkeit und verantwortungsvollen Tourismus in diesem Paket war lobenswert.`,
    "comment_25": `Die Erinnerungen, die ich während des Tourismuspakets gesammelt habe, werden mich für immer begleiten.`,
    "comment_26": `Die Leidenschaft und Expertise der lokalen Guides verliehen dem Tourismuspaket eine zusätzliche Tiefe.`,
    "comment_27": `Das Tourismuspaket führte mich zu neuen Aktivitäten und Erfahrungen, die ich sonst nie ausprobiert hätte.`,
    "comment_28": `Ich hatte das Gefühl, mit dem Tourismuspaket in eine andere Welt eingetreten zu sein.`,
    "comment_29": `Das Tourismuspaket ermöglichte es mir, mich zu entspannen und abzuschalten, während ich ein neues Reiseziel erkundete.`,
    "comment_30": `Ich würde dieses Tourismuspaket ohne zu zögern wieder buchen; es war wirklich bemerkenswert.`,

    "需要帮助吗？": "Brauchen Sie Hilfe?",
    "点击下方按钮链接进入我们的客服在线聊天": "Klicken Sie auf die Schaltfläche unten, um unseren Live-Chat zu öffnen",
    "客服时间": "Kundendienstzeiten",
    "联系客服": "Kundendienst kontaktieren",

    "欢迎来到": "Willkommen bei",
    "index_text_1": "Wir sind führend im Unterkunftsmarketing und bieten Zugang zu über 2,7 Millionen Hotels weltweit über mehr als 320 Anbieter. Unsere Leistungen umfassen außerdem Flug- und Zugtickets, Flughafentransfers und Mietwagen.",
    "从今天开始": "Beginnen Sie noch heute",

    "home_1_1": `Das Tour-Buchungssystem, das Ihr Geschäft um 35 % wachsen lässt.`,
    "home_1_2": `Online-Buchungssoftware für Reiseveranstalter, Aktivitätsanbieter und Wiederverkäufer, um Prozesse zu automatisieren, Zeit zu sparen, Vernetzung zu ermöglichen und zu wachsen.`,
    "home_2_t": `Tourmanagement leicht gemacht`,
    "home_2_1": `Erhalten Sie die Funktionen des Buchungssystems, die Sie zur End-to-End-Verwaltung von Touren und Aktivitäten benötigen.`,
    "home_2_2": `Die Software hilft Ihnen, Ihr erlebnisbasiertes Geschäft zu verwalten, indem sie Aufgaben wie Buchungsmanagement automatisiert,`,
    "home_2_3": `Kommunikation, Reporting und Abrechnung. Voll flexibel und an Ihre Geschäftsbedürfnisse anpassbar. Gewinnen Sie Zeit zurück, um`,
    "home_2_4": `sich darauf zu konzentrieren, Ihren Gästen unvergessliche Erlebnisse zu bieten.`,
    "home_3_t": `Angebot und Nachfrage vernetzen`,
    "home_3_1": `Die Rezdy-Distributionsplattform bietet preisgekrönte Verbindungen zu Tausenden von globalen und lokalen Wiederverkäufern wie`,
    "home_3_2": `Viator und Google Things to do sowie Tools, um jeden Kanal nahtlos zu verwalten. Verbinden Sie Ihre Touren einfach über eine`,
    "home_3_3": `einzelne verwaltete Verbindung, um neue Einnahmequellen zu erschließen. Rezdy verbindet Sie mit dem größten unabhängigen Angebot`,
    "home_3_4": `und Vertriebsnetzwerk in der gesamten Erlebnisbranche.`,
    "home_4_t": `Wachsen Sie mit führenden Integrationspartnern der Reisebranche`,
    "home_4_1": `Wir verbinden Sie mit Partnern der Tourismusbranche weltweit – über 25.000 Wiederverkäufer global und lokal und mehr als 100.000`,
    "home_4_2": `Erlebnissen weltweit.`,
    "home_5_t": `Rezdy erzielt Ergebnisse. So unterstützen wir Anbieter weltweit:`,
    "home_5_1": `Durchschnittliche Steigerung direkter Online-Buchungen`,
    "home_5_2": `Mehr Umsatz durch OTAs und Vertriebspartner`,
    "home_5_3": `Jährliche Stundenersparnis bei der Buchungsverwaltung`,
    "©版权所有XXX2025": "© XXX 2025 Alle Rechte vorbehalten",
}